import { ref } from 'vue';
import { useIntersectionObserver } from '@vueuse/core';
import websiteConfig from '@/configs/websiteConfig';
const worldText = websiteConfig.world.worldText; // 板块目录
export default function () {
  const worldRef = ref(null);
  const targetIsVisible = ref(false);
  const worldPic = ref(0);
  const { isSupported } = useIntersectionObserver(worldRef, ([{ isIntersecting }], observerElement) => {
    targetIsVisible.value = isIntersecting;
  });
  const changeBackground = (swiper) => {
    targetIsVisible.value = false;
    worldPic.value = swiper.activeIndex
    setTimeout(() => {
      targetIsVisible.value = true;
    }, 180)
  }
  const outsideSwiperConfig = {
    el: '.world-pagination',
    clickable: true,
    bulletClass: 'thumb',
    bulletActiveClass: 'active',
    renderBullet: function (index, className) {
      return `
                   <a href="javascript:;" class="${className} ${className}-${
        index + 1
      }" data-reason="world" data-type="${index}"></a>
`;
    },
  };
  return {
    worldText,
    outsideSwiperConfig,
    worldRef,
    targetIsVisible,
    isSupported,
    changeBackground,
    worldPic,
    websiteConfig
  };
}
